import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  FormatDateToWord,
  CustomerSelect,
  PlateNoSelect,
  ItemSelect,
  SalesInvoiceOptionalCustomerSelect,
  DriversSelect,
  FormatTimeTo12Hour
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';

export default function DeliveryOrderReport() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  // const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [plateNo, setPlateNo] = useState("");
  const [driver, setDriver] = useState("");
  const [invoice, setInvoice] = useState(null);

  const [customer, setCustomer] = useState(null);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);

  const openCustomerSelect = () => {
    setShowCustomerSelect(true)
  }
  const closeCustomerSelect = () => {
    setShowCustomerSelect(false)
  }

  const [item, setItem] = useState(null);
  const [showItemSelect, setShowItemSelect] = useState(false);

  const openItemSelect = () => {
    setShowItemSelect(true)
  }
  const closeItemSelect = () => {
    setShowItemSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async () => {
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      customerId: customer ? customer?.customerId : null,
      itemCode: item ? item.itemCode : null,
      driver: driver ? driver : null,
      plateNo: plateNo ? plateNo : null,
      documentId: invoice ? invoice?.id : null,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/delivery-report`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo, customer, item, driver, plateNo, invoice]);

  // PDF
  const generatePerDriverPlateNo = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_SUMMARY_OF_DELIVERY_PER_DRIVER_PLATE_NO.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 12;

      let grandVatable = 0;
      let grandVat = 0;
      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      };

      for (const record of _data) {
        // Check space for Customer Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.driver ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        let subVatable = 0;
        let subVat = 0;
        let subAmount = 0;

        for (const order of record.deliveryOrders) {
          for (const itemRow of order.items) {
            const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
            const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);

            // --- PAGE BREAK CHECK FOR ITEM ROW ---
            if (yPosition - rowHeight < bottomThreshold) {
              await addNewPage();
            }

            // Draw Row Data
            currentPage.drawText(FormatDateToMDY(order.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${record?.plateNo ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${order?.referenceNumber ?? ""}`, { x: 135, y: yPosition, size: 8, font: calibriFont });

            const truncatedCustomerName1 = truncateText(order?.customerName1 ?? "", 120, calibriFont, 8);
            currentPage.drawText(truncatedCustomerName1, { x: 200, y: yPosition, size: 8, font: calibriFont });

            // Draw wrapped description
            for (let i = 0; i < descLines.length; i++) {
              currentPage.drawText(descLines[i], {
                x: 300,
                y: yPosition - i * lineHeight,
                size: 8,
                font: calibriFont,
              });
            }

            const qtyVal = parseFloat(itemRow.quantity) || 0;
            currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 405, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 435, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 470, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 530, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 592, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 650, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 714, y: yPosition, size: 8, font: calibriFont });

            yPosition -= rowHeight + 5;
            subVatable += itemRow.vaTableSales || 0;
            subVat += itemRow.vat || 0;
            subAmount += itemRow.totalAmount || 0;

            grandVatable += itemRow.vaTableSales || 0;
            grandVat += itemRow.vat || 0;
            grandAmount += itemRow.totalAmount || 0;
          }
        }

        // --- PAGE BREAK CHECK FOR CUSTOMER SUB-TOTAL ---
        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Driver Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 530, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 592, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subVat)}`, { x: 650, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 714, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; // Extra spacing between customers
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 530, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 592, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVat)}`, { x: 650, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 714, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_SUMMARY_OF_DELIVERY_PER_DRIVER_PLATE_NO.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePerDriverPlateNoTimeDepart = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_SUMMARY_OF_DELIVERY_PER_DRIVER_PLATE_NO_TIME_DEPART.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandVatable = 0;
      let grandVat = 0;
      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      };

      for (const record of _data) {
        // Check space for Customer Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.driver ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        let subVatable = 0;
        let subVat = 0;
        let subAmount = 0;

        for (const order of record.deliveryOrders) {
          for (const itemRow of order.items) {
            // --- PAGE BREAK CHECK FOR ITEM ROW ---
            if (yPosition - lineHeight < bottomThreshold) {
              await addNewPage();
            }

            // Draw Row Data
            currentPage.drawText(FormatDateToMDY(order.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${record?.plateNo ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(FormatTimeTo12Hour(record.timeDeparture), { x: 140, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${order?.referenceNumber ?? ""}`, { x: 185, y: yPosition, size: 8, font: calibriFont });

            const truncatedCustomerName1 = truncateText(order?.customerName1 ?? "", 80, calibriFont, 8);
            currentPage.drawText(truncatedCustomerName1, { x: 248, y: yPosition, size: 8, font: calibriFont });

            const truncatedItem = truncateText(itemRow?.itemDescription ?? "", 80, calibriFont, 8);
            currentPage.drawText(truncatedItem, { x: 325, y: yPosition, size: 8, font: calibriFont });

            const qtyVal = parseFloat(itemRow.quantity) || 0;
            currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 407, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 440, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 470, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 525, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 583, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 642, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 695, y: yPosition, size: 8, font: calibriFont });

            yPosition -= lineHeight;
            subVatable += itemRow.vaTableSales || 0;
            subVat += itemRow.vat || 0;
            subAmount += itemRow.totalAmount || 0;

            grandVatable += itemRow.vaTableSales || 0;
            grandVat += itemRow.vat || 0;
            grandAmount += itemRow.totalAmount || 0;
          }
        }

        // --- PAGE BREAK CHECK FOR CUSTOMER SUB-TOTAL ---
        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Driver Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 525, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 583, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subVat)}`, { x: 642, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 695, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; // Extra spacing between customers
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 525, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 583, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVat)}`, { x: 642, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 695, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_SUMMARY_OF_DELIVERY_PER_DRIVER_PLATE_NO_TIME_DEPART.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  //Excel
  const exportPerDriverPlateNoExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData; // Assuming this is the grouped list by Driver

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Summary per Driver');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Title and Filters
      worksheet.addRow(['SALES SUMMARY OF DELIVERY PER DRIVER / PLATE NO.']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Plate No.',
        'Doc. No.',
        'Customer',
        'Item',
        'Qty',
        'UOM',
        'Net Price',
        'VATable Sales',
        'VATable',
        'VAT',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows logic
      let grandVatable = 0;
      let grandVat = 0;
      let grandAmount = 0;

      _data.forEach(record => {
        // Driver Group Header
        const driverHeaderRow = worksheet.addRow([`Driver: ${record.driver ?? "N/A"}`]);
        driverHeaderRow.font = { bold: true };
        driverHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${driverHeaderRow.number}:D${driverHeaderRow.number}`);

        let subVatable = 0;
        let subVat = 0;
        let subAmount = 0;

        record.deliveryOrders.forEach(order => {
          order.items.forEach(itemRow => {
            const row = worksheet.addRow([
              FormatDateToMDY(order.date),
              record.plateNo ?? "",
              order.referenceNumber ?? "",
              order.customerName1 ?? "",
              itemRow.itemDescription ?? "",
              parseFloat(itemRow.quantity || 0),
              itemRow.uomName ?? "",
              parseFloat(itemRow.netPrice || 0),
              parseFloat(itemRow.vaTableSales || 0), // Vatable Sales
              parseFloat(itemRow.vaTableSales || 0), // Total Vatable (following your PDF logic)
              parseFloat(itemRow.vat || 0),
              parseFloat(itemRow.totalAmount || 0),
            ]);

            // Formatting numbers
            [6, 8, 9, 10, 11, 12].forEach(colIndex => {
              row.getCell(colIndex).numFmt = '#,##0.00';
            });
            
            row.getCell(5).alignment = { wrapText: true }; // Wrap Item Description

            // Accumulate subtotals
            subVatable += (itemRow.vaTableSales || 0);
            subVat += (itemRow.vat || 0);
            subAmount += (itemRow.totalAmount || 0);
          });
        });

        // 6. Driver Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Driver Sub-Total:`, '', '', '', '', '', '', '', 
          subVatable, 
          subVatable, 
          subVat, 
          subAmount
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        [9, 10, 11, 12].forEach(colIndex => {
            subTotalRow.getCell(colIndex).numFmt = '#,##0.00';
            subTotalRow.getCell(colIndex).border = { top: { style: 'thin' } };
        });

        grandVatable += subVatable;
        grandVat += subVat;
        grandAmount += subAmount;

        worksheet.addRow([]); // Gap between drivers
      });

      // 7. Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', 
        grandVatable, 
        grandVatable, 
        grandVat, 
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      [9, 10, 11, 12].forEach(colIndex => {
          grandTotalRow.getCell(colIndex).numFmt = '#,##0.00';
          grandTotalRow.getCell(colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
          grandTotalRow.getCell(colIndex).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
      });

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 12 }, // Plate No
        { width: 15 }, // Ref No
        { width: 25 }, // Customer
        { width: 35 }, // Item Description
        { width: 10 }, // Qty
        { width: 8 },  // UOM
        { width: 12 }, // Net Price
        { width: 15 }, // Vatable Sales
        { width: 15 }, // Total Vatable
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Summary_Per_Driver_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPerDriverPlateNoTimeDepartExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Summary (Time Depart)');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Title and Filters
      worksheet.addRow(['SALES SUMMARY OF DELIVERY PER DRIVER / PLATE NO / TIME DEPART']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns (Note: Added Time Depart)
      const headerRow = worksheet.addRow([
        'Date',
        'Plate No.',
        'Time Depart',
        'Doc. No.',
        'Customer',
        'Item',
        'Qty',
        'UOM',
        'Net Price',
        'VATable Sales',
        'VATable',
        'VAT',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows logic
      let grandVatable = 0;
      let grandVat = 0;
      let grandAmount = 0;

      _data.forEach(record => {
        // Driver Group Header
        const driverHeaderRow = worksheet.addRow([`Driver: ${record.driver ?? "N/A"}`]);
        driverHeaderRow.font = { bold: true };
        driverHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${driverHeaderRow.number}:D${driverHeaderRow.number}`);

        let subVatable = 0;
        let subVat = 0;
        let subAmount = 0;

        record.deliveryOrders.forEach(order => {
          order.items.forEach(itemRow => {
            const row = worksheet.addRow([
              FormatDateToMDY(order.date),
              record.plateNo ?? "",
              FormatTimeTo12Hour(record.timeDeparture), // Added Time Depart
              order.referenceNumber ?? "",
              order.customerName1 ?? "",
              itemRow.itemDescription ?? "",
              parseFloat(itemRow.quantity || 0),
              itemRow.uomName ?? "",
              parseFloat(itemRow.netPrice || 0),
              parseFloat(itemRow.vaTableSales || 0),
              parseFloat(itemRow.vaTableSales || 0), // Total Vatable
              parseFloat(itemRow.vat || 0),
              parseFloat(itemRow.totalAmount || 0),
            ]);

            // Formatting numbers (Columns G through M)
            [7, 9, 10, 11, 12, 13].forEach(colIndex => {
              row.getCell(colIndex).numFmt = '#,##0.00';
            });
            
            row.getCell(5).alignment = { wrapText: true }; // Wrap Customer
            row.getCell(6).alignment = { wrapText: true }; // Wrap Item

            // Accumulate subtotals
            subVatable += (itemRow.vaTableSales || 0);
            subVat += (itemRow.vat || 0);
            subAmount += (itemRow.totalAmount || 0);
          });
        });

        // 6. Driver Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Driver Sub-Total:`, '', '', '', '', '', '', '', '',
          subVatable, 
          subVatable, 
          subVat, 
          subAmount
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        // Apply number format to the subtotal sums (Columns 10, 11, 12, 13)
        [10, 11, 12, 13].forEach(colIndex => {
            subTotalRow.getCell(colIndex).numFmt = '#,##0.00';
            subTotalRow.getCell(colIndex).border = { top: { style: 'thin' } };
        });

        grandVatable += subVatable;
        grandVat += subVat;
        grandAmount += subAmount;

        worksheet.addRow([]); // Gap between drivers
      });

      // 7. Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', '',
        grandVatable, 
        grandVatable, 
        grandVat, 
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      [10, 11, 12, 13].forEach(colIndex => {
          grandTotalRow.getCell(colIndex).numFmt = '#,##0.00';
          grandTotalRow.getCell(colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
          grandTotalRow.getCell(colIndex).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
      });

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 12 }, // Plate No
        { width: 12 }, // Time Depart (New)
        { width: 15 }, // Ref No
        { width: 25 }, // Customer
        { width: 30 }, // Item Description
        { width: 10 }, // Qty
        { width: 8 },  // UOM
        { width: 12 }, // Net Price
        { width: 15 }, // Vatable Sales
        { width: 15 }, // Total Vatable
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Summary_Driver_TimeDepart_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasDeliveryReport) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Delivery Report`}
            </h2>
            <p className="text-gray-500 mt-1">Report of all Delivery Report.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Customer 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Customer"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                readOnly
              />
              {!customer ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Item 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Item"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${item ? `${item?.itemCode} - ${item?.itemDescription}` : ""}`}
                readOnly
              />
              {!item ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openItemSelect}>
                  <SearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setItem(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Driver
            </label>
            <DriversSelect data={driver} setData={setDriver} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Plate No.
            </label>
            <PlateNoSelect data={plateNo} setData={setPlateNo} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Document No.
            </label>
            <SalesInvoiceOptionalCustomerSelect data={invoice} setData={setInvoice} isEditable={true} customerId={customer ? customer?.customerId : "All"}/>
          </div>

        </div>

        <div className="mt-5 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 px-2">Generate Reports</h2>

          {/* Header Row - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-4 mb-2 text-xs font-black uppercase tracking-widest text-gray-400">
            <div className="col-span-2">Report Category</div>
            <div className="col-span-5">PDF Reports</div>
            <div className="col-span-5 border-l border-gray-100">Excel Reports</div>
          </div>

          <div className="space-y-3">
            {[
              { 
                label: "Per Driver and Plate No.", 
                pdf_summarized: generatePerDriverPlateNo, 
                excel_summarized: exportPerDriverPlateNoExcel, // Replace with your Excel function
              },
              { 
                label: "Per Driver, Plate No. and Time Depart", 
                pdf_summarized: generatePerDriverPlateNoTimeDepart,
                excel_summarized: exportPerDriverPlateNoTimeDepartExcel 
              },
            ].map((group, idx) => (
              <div key={idx} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                
                {/* Label */}
                <div className="col-span-2">
                  <span className="text-sm font-bold text-gray-700">{group.label}</span>
                </div>

                {/* PDF Column */}
                <div className="col-span-5 flex flex-wrap gap-2">
                  {group.pdf_detailed &&
                    <button 
                      onClick={group.pdf_detailed} 
                      className="flex items-center gap-2 bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 transition-all active:scale-95"
                      title="Download PDF Detailed"
                    >
                      <RestartAltIcon sx={{ fontSize: 16 }} /> Detailed
                    </button>
                  }
                  
                  {group.pdf_summarized &&
                    <button 
                      onClick={group.pdf_summarized} 
                      className="flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-50 transition-all active:scale-95"
                    >
                      Summarized
                    </button>
                  }

                  {group.pdf_extra && (
                    <button 
                      onClick={group.pdf_extra} 
                      className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-blue-100 transition-all active:scale-95"
                    >
                      Summarized w/ %
                    </button>
                  )}
                </div>

                {/* Excel Column */}
                <div className="col-span-5 flex flex-wrap gap-2 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0">
                  {group.excel_detailed &&
                    <button 
                      onClick={group.excel_detailed} 
                      className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 shadow-sm transition-all active:scale-95"
                    >
                      Excel Detailed
                    </button>
                  }
                  
                  {group.excel_summarized &&
                    <button 
                      onClick={group.excel_summarized} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ.
                    </button>
                  }
                  
                  
                  { group.excel_extra &&
                    <button 
                      onClick={group.excel_extra} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ. w/ %
                    </button>
                  }
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>
      
      <CustomerSelect 
        visible={showCustomerSelect} 
        onClose={closeCustomerSelect}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />
      
      <ItemSelect 
        visible={showItemSelect} 
        onClose={closeItemSelect}
        modalName={"Select Item"}
        data={item} setData={setItem}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}